import React, { useEffect, useState } from 'react';
import {
  Button,
  DatePicker,
  Form,
  Input,
  message,
  Radio,
  Select,
  Space,
} from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import {
  getBannerDetail,
  saveOrUpdateBanner,
  BannerDetail,
} from '@/api/banner';
import { PageLink } from '@/config/pageConfig';
import UploadImage from '@/components/UploadImage';

const BannerMngDetailPage: React.FC = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const isEdit = Boolean(id);
  const jumpType = Form.useWatch('jumpType', form);

  useEffect(() => {
    if (isEdit) {
      getBannerDetail({ id: Number(id) }).then((res) => {
        if (res.status === 200 && res.data.success) {
          const detail: BannerDetail = res.data.data;
          form.setFieldsValue({
            ...detail,
            publishTime: detail.publishTime ? dayjs(detail.publishTime) : null,
          });
        }
      });
    }
  }, [id, form, isEdit]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        ...values,
        sort: Number(values.sort),
        publishTime: values.publishTime
          ? values.publishTime.format('YYYY-MM-DD HH:mm:ss')
          : '',
        jumpContent: values.jumpContent || '',
        id: id ? Number(id) : null,
      };
      setLoading(true);
      const res = await saveOrUpdateBanner(payload);
      setLoading(false);
      if (res.status === 200 && res.data.success) {
        message.success('提交成功');
        navigate(PageLink.BannerMng);
      } else {
        message.error(res.data.message || '提交失败');
      }
    } catch (err) {
      console.error('表单验证失败', err);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Form form={form} initialValues={{ jumpType: 0, status: 0 }}>
        <Space style={{ marginBottom: 24 }}>
          <Form.Item
            label="图片上传（日）"
            name="imageJa"
            rules={[{ required: true }]}
          >
            <UploadImage
              width={800}
              height={400}
              maxSize={10}
              showSizeHint={false}
            />
          </Form.Item>
          <Form.Item
            label="图片上传（英）"
            name="image"
            rules={[{ required: true }]}
          >
            <UploadImage
              width={800}
              height={400}
              maxSize={10}
              showSizeHint={false}
            />
          </Form.Item>
        </Space>

        <Form.Item
          label="跳转链接"
          name="jumpType"
          rules={[{ required: true }]}
          style={{ maxWidth: 480 }}
        >
          <Radio.Group>
            <Radio value={0}>链接</Radio>
            <Radio value={1}>投票活动ID</Radio>
            {/* <Radio value={2}>contest列表</Radio>
            <Radio value={3}>AI作图</Radio> */}
          </Radio.Group>
        </Form.Item>

        {(jumpType === 0 || jumpType === 1) && (
          <Form.Item
            label="跳转内容"
            name="jumpContent"
            rules={[{ required: true, message: '请输入跳转内容' }]}
            style={{ maxWidth: 480 }}
          >
            <Input placeholder="输入链接/活动ID" />
          </Form.Item>
        )}

        <Form.Item
          label="轮播排序"
          name="sort"
          rules={[
            { required: true, message: '请输入轮播排序值' },
            {
              validator: (_, value) => {
                if (!value || !/^[1-9]\d*$/.test(String(value))) {
                  return Promise.reject();
                }
                return Promise.resolve();
              },
            },
          ]}
          style={{ maxWidth: 480 }}
        >
          <Input type="number" placeholder="数字越大越靠前" min={1} />
        </Form.Item>

        <Form.Item
          name="publishTime"
          label="发布时间"
          rules={[
            { required: true, message: '请选择发布时间' },
            {
              validator: (_, value: string) => {
                if (dayjs(value).isBefore(dayjs())) {
                  return Promise.reject(new Error('发布时间不能早于当前时间'));
                }
                return Promise.resolve();
              },
            },
          ]}
          style={{ maxWidth: 480 }}
        >
          <DatePicker
            showTime
            placeholder="请选择发布时间(日本时间)"
            style={{ width: '100%' }}
            format="YYYY-MM-DD HH:mm:ss"
          />
        </Form.Item>

        <Form.Item label="推送状态" name="status" style={{ maxWidth: 480 }}>
          <Select
            options={[
              { label: '下线', value: 0 },
              { label: '上线', value: 1 },
            ]}
          />
        </Form.Item>

        <Form.Item>
          <Space>
            <Button
              type="primary"
              htmlType="submit"
              onClick={handleSubmit}
              loading={loading}
            >
              提交
            </Button>
            <Button onClick={() => navigate(-1)}>取消</Button>
          </Space>
        </Form.Item>
      </Form>
    </div>
  );
};

export default BannerMngDetailPage;
